import i18n from "./i18n";
import React from 'react';
import ReactDOM from 'react-dom';
import { AuthProvider, Configuration, Dialog, Mask, ThemeService, WarningDialog, LocalCache } from "puzzle";

import App from './App';
import { BrowserRouter } from 'react-router-dom';

import actions from './actions';
// @ts-ignore
import Themes from "themes";

const { BASE_ROUTE_NAME } = Configuration.get();

const AppWrapper = () => {
  const impersonatorUsername = new URLSearchParams(window.location.search).get('Imp');
  if (impersonatorUsername) {
    LocalCache.setItem('impersonated', impersonatorUsername, 'sessionStorage');
    const { origin, pathname } = window.location;
    window.history.replaceState({}, 'Project Director', origin + pathname);
  }
  const t = i18n.t.bind(i18n);
  let routerOptions = BASE_ROUTE_NAME.length ? { basename: BASE_ROUTE_NAME } : {};
  ThemeService.init(Themes);
  return (
    <>
      <div id={'warning-modal-root'} />
      <div id={'dialog-modal-root'} />
      <div id={'widgets'} />
      <BrowserRouter {...routerOptions}>
        <AuthProvider moduleName={'AuthProvider'} t={t}>
          <App
            actions={actions}
            t={t}
            topLevelComponent={true}
          />
        </AuthProvider>
      </BrowserRouter>
      <WarningDialog t={t} />
      <Dialog t={t} />
    </>
  );
};

if (process.env.NODE_ENV === 'production') {
  // production mode
  ReactDOM.render(<Mask message="Loading application" />, document.getElementById('root'));
  i18n.on('initialized', loaded => {
    ReactDOM.render(<AppWrapper />, document.getElementById('root'));
  });
} else {
  // development mode
  ReactDOM.render(<AppWrapper />, document.getElementById('root'));
}
